import React, { useEffect } from "react"
import { Purchases } from "@revenuecat/purchases-js"
import { useLicenseKeyMutation } from "../mutations"
import { useStore } from "@nanostores/react"
import { $auth } from "../store/auth"
import { ActivateFlow } from "./ActivateFlow"

export type PurchaseType = 'new' | 'upgrade' | 'early-bird'

export const PurchaseContainer: React.FC<{
  onAccessGranted: () => void,
  purchaseType?: PurchaseType,
  onCancel?: () => void
}> = ({ onAccessGranted, purchaseType, onCancel }) => {

  const userState = useStore($auth)
  console.log("userState", userState)

  const {
    mutateAsync,
    isLoading: isSubmitLicenseKeyLoading,
    isError: isSubmitLicenseKeyError,
    isSuccess: isSubmitLicenseKeySuccess
  } = useLicenseKeyMutation()

  useEffect(() => {
    if (isSubmitLicenseKeySuccess) {
      onAccessGranted()
    }
  }, [isSubmitLicenseKeySuccess, onAccessGranted])

  const makePurchaseWithRCBilling = async () => {
    const OFFERING = "Basic access"
    const packageId = "basic"
    const offerings = await Purchases.getSharedInstance().getOfferings()
    const rcPackage = offerings?.all?.[OFFERING]?.packagesById?.[packageId]
    if (rcPackage) {
      try {
        const { customerInfo } = await Purchases.getSharedInstance().purchase({
          rcPackage,
          customerEmail: userState.user?.data?.signInDetails?.loginId
        })
        console.log("Purchase successful:", customerInfo)
      } catch (error) {
        console.error("Error purchasing with RevenueCat:", error)
      }
    }
  }

  return (
    <>
      <ActivateFlow purchaseType={purchaseType || 'new'} onAccessGranted={onAccessGranted} onCancel={onCancel} />
    </>
  )
}
